import { useAccountRepository } from '@frontend/repository';
import { useState } from 'react';

import { useAppDispatch } from '../../../../redux/store';
import { LinkCategoriesModalProps } from './link-categories-modal.component';

export const useLinkCategoriesModal = (props: LinkCategoriesModalProps) => {
    const dispatch = useAppDispatch();
    const [categories, setCategories] = useState<string[]>(props.groups.map((g) => g.id));
    const { currentAccount } = useAccountRepository();

    return {
        dispatch,
        categories,
        setCategories,
        currentAccount
    };
};
